/** Central API helper */

import logger from './logging';
import { supabase } from './supabase/supabase';

function normalizePath(path: string) {
    // TODO: Ensure this is a valid path (no double /)
    var normPath = '/api/' + path;

    return normPath;
}

async function getPayloadHash(payloadObj: any) {
    // If there's no body (e.g., an empty POST), SigV4 expects the hash of an empty string
    const bodyString = payloadObj ? JSON.stringify(payloadObj) : '';

    const encoder = new TextEncoder();
    const data = encoder.encode(bodyString);

    // Hash the payload using native browser crypto
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // Convert the buffer array to a hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
}

async function sendApiRequest(path: string, init?: RequestInit, auth: boolean = false, msgOnError = 'Unexpected error') {
    if (auth) {
        init = await addAuth(init);
    }
    if (init && ['POST', 'PUT', 'PATCH'].includes(init.method || '')) {
        if (!init.headers) {
            init.headers = {};
        }
        //@ts-ignore
        init.headers['x-amz-content-sha256'] = await getPayloadHash(init.body);
    }
    const response = await fetch(normalizePath(path), init);
    const payload = await response.json();
    if (!response.ok) {
        throw new Error(payload.error || msgOnError);
    }

    return payload;
}

export async function getCheckoutSession(planId: string, missionaryId: string) {
    const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !sessionData.session?.access_token) {
        throw new Error('You must be logged in to subscribe');
    }
    return await sendApiRequest('stripe/create-checkout', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionData.session.access_token}`
        },
        body: JSON.stringify({
            plan_id: planId,
            missionary_id: missionaryId,
            success_url: `${window.location.origin}/dashboard?session_id={CHECKOUT_SESSION_ID}`,
            cancel_url: `${window.location.origin}/dashboard`
        })
    });
}

export async function getMissionaryImages(missionaryId: string, page: number) {
    return await sendApiRequest(`missionary-images`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ missionary_id: missionaryId, page })
    },
        true);
}

async function addAuth(init?: RequestInit) {
    const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !sessionData.session?.access_token) {
        throw new Error('You must be logged in to subscribe');
    }
    if (!init) {
        init = {};
    }
    if (!init.headers) {
        init.headers = {};
    }
    init.headers['x-pfm-token'] = sessionData.session.access_token;
    return init;
}

export async function unsubscribe(token: string, email: string, type: string = 'single') {
    return await sendApiRequest('unsubscribe', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: token, email: email, type: type })
    },
        false,
        'Failed to unsubscribe');
}

export async function getMissionaryByUniqueId(uniqueId: string) {
    return await sendApiRequest(`missionary/${uniqueId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export async function validateUnsubscribeToken(token: string, email: string) {
    return await sendApiRequest('unsubscribe/validate', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: token, email: email })
    },
        false,
        'Failed to validate unsubscribe token');;
}
